import * as React from "react";
import { Change, SizedPrice, Variant } from "@bloomberg/media-ui-markets";
import styles from "./afterHoursPrice.module.css";
import assertNumericValue from "~utils/assertNumericValue";

export interface AfterHoursPriceProps {
  currentPrice?: number;
  percentChange?: number;
  priceChange?: number;
}

const AFTER_HOURS_ENABLED =
  process.env.NEXT_PUBLIC_AFTER_HOURS_ENABLED || "false";

export default function AfterHoursPrice(props: AfterHoursPriceProps) {
  const { currentPrice, percentChange, priceChange } = props;

  if (AFTER_HOURS_ENABLED === "false") {
    return null;
  }

  // if data is not present, empty div with fixed height is displayed to prevent CLS
  return (
    <div className={styles.afterHoursPriceContainer}>
      {assertNumericValue(currentPrice) &&
      assertNumericValue(percentChange) &&
      assertNumericValue(priceChange) ? (
        <>
          <span className={styles.afterHoursText}>After hours:</span>
          <SizedPrice price={currentPrice} />
          <Change
            className={styles.change}
            percentChange={percentChange}
            priceChange={priceChange}
            hideMarketArrow
            variant={Variant.refresh2024}
          />
        </>
      ) : (
        <div />
      )}
    </div>
  );
}
